import React from 'react'
import './Scss/Footer.scss'
import LocationOnIcon from '@material-ui/icons/LocationOn';
import PhoneIcon from '@material-ui/icons/Phone';
import EmailIcon from '@material-ui/icons/Email';

const Footer = () => {
    return (
        <footer>
            <div className="container">
                <div className="row">
                    <div className="col-lg-3 p-3">
                        <ul>
                            <li>
                                <img src="/images/logo.png" alt="footer"/>
                            </li>
                            <li>
                                <small>
                                    After a time we drew near the road, and as we did so we heard the clatter of hoofs and saw through the tree stems three cavalry soldiers riding slowly towards Woking.
                                </small>
                            </li>
                            <li><LocationOnIcon /> <small>518-520 5th Ave, New York, USA</small></li>
                            <li><PhoneIcon /> <small>(123) 345-6789</small></li>
                            <li><EmailIcon /> <small>linxiao0106@gmail.com</small></li>
                        </ul>
                    </div>
                    
                </div>
            </div>
            <div className="copy-right"><small>2020 Developed by Xiao Lin. All rights reserved.</small></div>
           
        </footer>
    )
}

export default Footer